import React, { useEffect, useState } from "react";
import { API } from "../../lib/api";

// Full-viewport regional scenery behind the Scanner once a city is scanned. Fades in on load,
// slow Ken-Burns drift, heavy nebula gradients keep the dark-luxury contrast for foreground text.
export function ScanBackdrop({ city }) {
  const [shown, setShown] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!city) return;
    setLoaded(false);
    setShown(city);
  }, [city]);

  if (!shown) return null;
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const w = window.innerWidth * dpr <= 1100 ? 960 : window.innerWidth * dpr <= 1700 ? 1440 : 1920;
  const src = `${API}/places/image?city=${encodeURIComponent(shown)}&planet=scenery&w=${w}`;

  return (
    <div className="fixed inset-0 -z-10 pointer-events-none overflow-hidden" data-testid="scan-backdrop" data-city={shown} aria-hidden>
      <img
        key={src}
        src={src}
        alt=""
        onLoad={() => setLoaded(true)}
        data-testid="scan-backdrop-image"
        className="absolute inset-0 w-full h-full object-cover transition-opacity duration-[1800ms] ease-out"
        style={{ opacity: loaded ? 0.55 : 0, animation: loaded ? "backdrop-drift 40s ease-in-out infinite alternate" : "none" }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#15111A]/85 via-[#15111A]/45 to-[#15111A]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#15111A]/70 via-transparent to-[#15111A]/70" />
      <style>{`@keyframes backdrop-drift { from { transform: scale(1.04) translate3d(0,0,0); } to { transform: scale(1.12) translate3d(-1.5%, -1%, 0); } }`}</style>
    </div>
  );
}
